import { useState } from "react";
import { Link } from "react-router-dom";
import "../../css/deleteAccountRequest.css";
import { useNavigate } from "react-router-dom";
import {
  FaTrashAlt,
  FaExclamationTriangle,
  FaDatabase,
  FaUserTimes,
  FaPhoneAlt,
  FaEnvelope,
  FaUser,
  FaCalendarAlt,
} from "react-icons/fa";
import DeleteAccountFlow from "../../pages/User/DeleteAccountFlow";

import ProfileProvider from "../../context/ProfileContext";

import logo from "../../assets/images/logo1.png";

export default function DeleteAccountRequest() {
  const [showDeleteFlow, setShowDeleteFlow] = useState(false);
  const navigate = useNavigate();

  const deleteAccountData = [
    {
      profileTitle: "Submit Deletion Request",
      profileDiscription: "Fill out the form to request account deletion",
      profileIcon: FaTrashAlt,
    },
    {
      profileTitle: "Verification Required",
      profileDiscription: "Verify your identity with registered details",
      profileIcon: FaPhoneAlt,
    },
    {
      profileTitle: "30 Days Processing",
      profileDiscription:
        "Your request will be processed within 30 days grace period",
      profileIcon: FaCalendarAlt,
    },
    {
      profileTitle: "Permanent Deletion",
      profileDiscription:
        "All data will be permanently removed after processing",
      profileIcon: FaDatabase,
    },
  ];

  const handleRequestDeletion = () => {
    setShowDeleteFlow(true);
  };

  return (
    <ProfileProvider>
      <div className="delete-account-page-wrapper">
        {/* Top Left Logo Section */}
        <div className="top-logo-section">
          <div className="logo-container">
            {/* Replace the src with your logo path */}
            <img src={logo} alt="Bharat Jagriti Logo" className="site-logo" />
            <span className="site-title" style={{ color: "#f4880c" }}>
              Bharat Jagriti
            </span>
          </div>
        </div>

        <div className="delete-account-center-container">
          <div className="deleteAccountRequest_container">
            <div className="deleteAccountRequest_container_section">
              <div className="deleteAccountRequest_section_title">
                <h2>Account Deletion Request</h2>
                <div className="notice-banner">
                  <FaExclamationTriangle />
                  <p>
                    To delete your account and all associated data, please fill
                    out this form. Your request will be processed with a{" "}
                    <strong>30-day grace period</strong>
                  </p>
                </div>
              </div>

              <div className="deleteAccountRequest_section">
                {deleteAccountData.map((item, idx) => {
                  return (
                    <div className="deleteAccountRequest_card" key={idx}>
                      <div className="deleteAccountRequest_icon">
                        <item.profileIcon />
                      </div>
                      <div className="deleteAccountRequest_policy">
                        <h3>{item.profileTitle}</h3>
                        <p>{item.profileDiscription}</p>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="deleteAccountRequest_bottom_section">
                <div className="deleteAccountRequest_button">
                  <button
                    onClick={() => handleRequestDeletion()}
                    className="delete-account-request-button"
                  >
                    Delete Account
                  </button>
                </div>
                <div className="deleteAccountRequest_info">
                  <p>
                    This action is irreversible. You'll have 30 days to cancel.
                  </p>
                </div>
                <div className="deleteAccountRequest_help">
                  <Link to={"/support-chat"}>
                    <p>Need Help? Contact Support</p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showDeleteFlow && (
          <DeleteAccountFlow onClose={() => setShowDeleteFlow(false)} />
        )}
      </div>
    </ProfileProvider>
  );
}
